const l = '<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16"><g clip-path="url(#a)"><path fill="currentColor" d="m8.541 10.446 3.272-3.333a.62.62 0 0 0 .124-.718A.73.73 0 0 0 11.27 6H4.727a.73.73 0 0 0-.664.396.62.62 0 0 0 .124.717l3.272 3.333c.138.14.334.22.54.22s.402-.08.54-.22z"/></g><defs><clipPath id="a"><path fill="currentColor" d="M0 0h16v16H0z"/></clipPath></defs></svg>';
export {
  l as default
};
